"use client"

import { useRef } from "react"
import {
    TextScrambleAnimation,
    type TextScrambleAnimationHandle,
} from "./scramble-text"
import { FastLink } from "../fast-link"
import { cn } from "@/lib/utils"

export function ScrambleFastLink({
    children,
    text,
    className,
    textContainerClassName,
    uppercase,
    ...rest
}: React.ComponentProps<typeof FastLink> & {
    text: string
    uppercase?: boolean
    textContainerClassName?: string
}) {
    const scrambleRef = useRef<TextScrambleAnimationHandle | null>(null)

    const handleMouseEnter = () => {
        scrambleRef.current?.play()
    }

    return (
        <FastLink
            className={cn("relative", className)}
            onMouseEnter={handleMouseEnter}
            {...rest}
        >
            <TextScrambleAnimation
                text={text}
                ref={scrambleRef}
                uppercase={uppercase}
                className={cn(textContainerClassName)}
            />
            {children}
        </FastLink>
    )
}
